import React from 'react'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-forest-900 flex flex-col items-center justify-center gap-4">
      <div className="w-10 h-10 rounded-xl bg-gold-500 flex items-center justify-center animate-pulse-soft">
        <span className="text-forest-900 font-display font-800 text-lg">T</span>
      </div>
      <div className="flex gap-1.5">
        <span className="w-2 h-2 rounded-full bg-forest-400 animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 rounded-full bg-forest-400 animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 rounded-full bg-forest-400 animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  )
}
